module.exports = __webpack_public_path__ + "img/世界加热部.eefef2c5.jpg";